import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// CONSTANTS
import { USER_COUNTRY } from "../constants/constants";
import { CountryCode, CountryCurrency } from "../constants/countryCurrency";
import { useEffect, useState } from "react";

const NumberSeparator = ({ title, number, platform, fixedSpend, showCurrency = true }) => {
  // USER DATA
  const userData = useSelector((state) => state.userData.user[0]);
  const genericUnformatted = ['adset id', 'id', 'io id', 'creative id', 'insertion order id'];

  let userCountryCode = userData?.country_code ?? "IN";
  const [formattedNumber, setFormattedNumber] = useState(0);

  useEffect(() => {
    let country = {};
    CountryCode.map((data) => {
      if (data.countryCode === userCountryCode) {
        country = data;
      }
    });

    if (number === "N/A") {
      setFormattedNumber(number);
      return;
    }

    let numberValue = Number(number);

    if (!title) {
      title = "";
    }

    const genericCurrency = ['spend', 'cpm', 'value', 'cprp', 'cpc'];
    const genericPercent = ['%', 'change', 'rate','growth'];
    const genericTime = ['duration'];
    const genericTonnes = ['monthly sales vol.'];
    const edgeCasesArray = ['benchmark cpm', 'benchmark cpv', 'benchmark cpc', 'cpcv'];

    if (fixedSpend === true) {
      genericCurrency.map((str) => {
        if (title.toLowerCase().includes(str)) {
          if (country.countryCode === "UAE") {
            numberValue = numberValue.toLocaleString("en-US", { maximumFractionDigits: 0 });
          } else {
            numberValue = numberValue.toLocaleString('en-IN', { maximumFractionDigits: 0 });
          }
        } else {
          if (country.countryCode === "UAE") {
            numberValue = numberValue.toLocaleString("en-US", { maximumFractionDigits: 2 });
          } else {
            numberValue = numberValue.toLocaleString('en-IN', { maximumFractionDigits: 2 });
          }
        }
      });
    } else {
      if (country.countryCode === "UAE") {
        numberValue = numberValue.toLocaleString("en-US", { maximumFractionDigits: 2 });
      } else {
        numberValue = numberValue.toLocaleString('en-IN', { maximumFractionDigits: 2 });
      }
    }

    genericTime.map((str) => {
      if (title.toLowerCase().includes(str)) {
        numberValue = numberValue + "s";
      }
    });

    genericPercent.map((str) => {
      if (title.toLowerCase().includes(str) && !numberValue.toString().includes('%')) {
        numberValue = numberValue + "%";
      }
    });

    // genericCurrency.map((str) => {
    //   if (
    //     title.toLowerCase().includes(str) &&
    //     !numberValue.toString().includes('%') &&
    //     !numberValue.toString().includes(country.currencySymbol)
    //   ) {
    //     if (!showCurrency) {
    //       // Don't add currency symbol
    //       numberValue = numberValue;
    //     } else if (platform === 'Twitter') {
    //       numberValue = country.alternateCurrencySymbol + numberValue;
    //     } else {
    //       numberValue = country.currencySymbol + numberValue;
    //     }
    //   }
    // });

    genericTonnes.map((str) => {
      if (title.toLowerCase().includes(str) && !numberValue.toString().includes('%')) {
        numberValue = numberValue + " T";
      }
    });

    edgeCasesArray.map((str) => {
      if (title.toLowerCase().includes(str)) {
        numberValue = number;
      }
    });

    setFormattedNumber(numberValue);
  }, [title, number, showCurrency, platform, fixedSpend, userCountryCode]);

  if (genericUnformatted.some((str) => str === title.toLowerCase())) {
    return number;
  }

  return formattedNumber;
};

NumberSeparator.propTypes = {
  number: PropTypes.number,
  title: PropTypes.string,
  platform: PropTypes.string,
  fixedSpend: PropTypes.bool,
  showCurrency: PropTypes.bool,
};

export default NumberSeparator;